import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import AdminDashboard from './AdminDashboard'
import UserDashboard from './UserDashboard'
import ReportList from '../Reports/ReportList'
import CPCDashboard from '../CPC/CPCDashboard';

const DashboardSection = (props) => {
    const history = useHistory();
    const isSysadmin = useSelector((state) => state.user.isSysadmin)
    const userGroup = useSelector((state) => state.user.userGroup)
    const usesCPC = useSelector((state) => state.user.company.uses_cpc ?? false)

    if(window.location.pathname !== "/logout/" && userGroup === '4') {
        history.push("/reports/")
    }   
    
    if(isSysadmin) return <AdminDashboard />
    else if(userGroup === '4') return <ReportList />
    else if(usesCPC) return <CPCDashboard />

    return (
        <>
        <UserDashboard />
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(DashboardSection), "Dashboard"));
